export default __webpack_public_path__ + "static/media/kabaranak-2.95363b3c.png";